"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowCardInstructions = void 0;
var react_1 = __importDefault(require("react"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
/**
 * Component that renders the instructions content for the workflow card.
 *
 * @param instructions text to display as instructions
 * @param divider whether or not to show a divider below the instructions
 *
 * @category Component
 */
var WorkflowCardInstructions = function (props) {
    var instructions = props.instructions, _a = props.divider, divider = _a === void 0 ? true : _a, sx = props.sx, otherProps = __rest(props, ["instructions", "divider", "sx"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        typeof instructions === 'string' ? (react_1.default.createElement(Typography_1.default, __assign({ sx: __spreadArray([{ px: { md: 3, xs: 2 }, pt: 2 }], (Array.isArray(sx) ? sx : [sx]), true) }, otherProps), instructions)) : (instructions),
        divider ? react_1.default.createElement(Divider_1.default, { sx: { mt: 5, mb: 4, mx: { md: -3, xs: -2 } } }) : null));
};
exports.WorkflowCardInstructions = WorkflowCardInstructions;
